import { AbstractValidatedClass, Joi, ValidatedClass, constraint } from '@verclam/form-validator';

type RecoveryCodeFormArgs = {
	recoveryCode: string;
};

@ValidatedClass()
class RecoveryCodeFormData extends AbstractValidatedClass<RecoveryCodeFormArgs> {
	@constraint(Joi.string().required(), () => 'Le code de récupération est obligatoire')
	public readonly recoveryCode: string;

	constructor(data: RecoveryCodeFormArgs) {
		super(data);
		this.recoveryCode = data.recoveryCode;
		Object.freeze(this);
	}

	static createEmpty(): RecoveryCodeFormData {
		return new RecoveryCodeFormData({ recoveryCode: '' });
	}

	setRecoveryCode(recoveryCode: string): this {
		return this.cloneWith({ recoveryCode } as Partial<RecoveryCodeFormArgs>);
	}
}

export default RecoveryCodeFormData;
